export const Reducer = (state = [], action) => {
  switch (action.type) {
    case "add_to_cart":
      {
        let flag = true;
        const it = action.payload;
        state.map((item) => {
          if (item.barcode === it.barcode) {
            flag = false;
          }
        });
        if (flag) {
          return [...state, action.payload];
        }
      }
      break;

    case "set_qty": {
      const it = action.payload;
      return state.map((item) => {
        if (item.barcode === it.barcode) {
          item.qty = it.qty;
        }
        return { ...item };
      });
    }
    case "remove_item":
      return state.filter((item) => {
        return item.barcode !== action.payload.barcode;
      });

    case "clear_cart":
      return [];

    default:
      return state;
  }
};

export const ReducerPromoProductsData = (state = "abc", action) => {
  switch (action.type) {
    case "get_pomo_products_data": {
      return action.data;
    }
    default:
      return state;
  }
};

export const ReducerNewProductsData = (state = "abc", action) => {
  switch (action.type) {
    case "get_new_products_data": {
      return action.data;
    }
    default:
      return state;
  }
};

export const ReducerAllProducts = (state = "abc", action) => {
  switch (action.type) {
    case "get_allproducts_data": {
      return action.data;
    }
    default:
      return state;
  }
};

export const ReducerDepData = (state = "abc", action) => {
  switch (action.type) {
    case "get_department_data": {
      return action.data;
    }
    default:
      return state;
  }
};

export const ReducerChangeName = (state = "abc", action) => {
  switch (action.type) {
    case "change_name": {
      return (state = action.payload);
    }
    default:
      return state;
  }
};

export const ReducerBrandProducts = (state = "abc", action) => {
  switch (action.type) {
    case "get_brandproducts_data": {
      return action.data;
    }
    default:
      return state;
  }
};

export const ReducerVegProducts = (state = "abc", action) => {
  switch (action.type) {
    case "get_vegproducts_data": {
      return action.data;
    }
    default:
      return state;
  }
};

export const ReducerBrandsData = (state = "abc", action) => {
  switch (action.type) {
    case "get_Brand_data": {
      return action.data;
    }
    default:
      return state;
  }
};

export const LoginData = (state = "abC ", action) => {
  switch (action.type) {
    case "login_data_checkout": {
      return action.data;
    }
    default:
      return state;
  }
};
